import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type OrganizationBilling } from '../../entity/api/organization-billing';
import { createBasicStoreState } from './basic-store';

type TModel = OrganizationBilling;

/**
 * Organization Billing Zustand Store
 *
 * This store now only provides:
 * - Basic store methods (clearStore, updateToStore, etc.) for socket updates
 * - Sync state for socket handlers
 *
 * For data fetching and mutations, use TanStack Query hooks from organization-billing-queries.ts:
 * - useOrganizationBilling(orgId)
 * - useSyncBillingWithProvider()
 * - useCheckProviderSession()
 * - useSubscribeOrganization()
 * - useCancelSubscription()
 * - useUnCancelSubscription()
 * - useUpdateSubscription()
 * - useRequestBillingPortalUrl()
 */
type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'organization-billing' }
  )
);
